import "bootstrap/dist/js/bootstrap.bundle.min.js";

window.bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min.js");